import { Dictionary } from '@shared/dictionary';

export const SPECIALIZATION_LEVELS: Record<string, Specializations.Level> = {
  AS: 'AS',
  BS: 'BS',
  MS: 'MS',
  PhD: 'PhD',
};

export const getSpecializationLevelLabel = (dictionary: Dictionary, level: Specializations.Level): string => {
  const MAP = {
    AS: 'Associate\'s Degree',
    BS: 'Bachelor\'s Degree',
    MS: 'Master\'s Degree',
    PhD: 'Doctoral Degree',
  };

  return MAP[level];
};
